export enum LogTypeEnum {
    LOG = 'log',
    DEBUG = 'debug',
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error',
}
